/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BBox
 */
export interface BBox {
    /**
     * 
     * @type {Array<number>}
     * @memberof BBox
     */
    extent: Array<number>;
}

/**
 * Check if a given object implements the BBox interface.
 */
export function instanceOfBBox(value: object): value is BBox {
    if (!('extent' in value) || value['extent'] === undefined) return false;
    return true;
}

export function BBoxFromJSON(json: any): BBox {
    return BBoxFromJSONTyped(json, false);
}

export function BBoxFromJSONTyped(json: any, ignoreDiscriminator: boolean): BBox {
    if (json == null) {
        return json;
    }
    return {
        
        'extent': json['extent'],
    };
}

export function BBoxToJSON(json: any): BBox {
    return BBoxToJSONTyped(json, false);
}

export function BBoxToJSONTyped(value?: BBox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'extent': value['extent'],
    };
}

